// Module
var code = "<div class=\"layout-column layout-align-center-center\" mn-bind-html=\"stand-alone/image-edition/views/actions.tpl.html\"></div>\r\n\r\n<div class=\"canvas flex\"></div>\r\n\r\n<md-content mn-bind-html=\"stand-alone/image-edition/views/options.tpl.html\"></md-content>\r\n";
// Exports
module.exports = code;